import PropTypes from 'prop-types';
import { Button } from '@etg/wings';
import { useTranslation } from '@eti/providers';

const ItineraryOverlayTrigger = ({ className, onClick, ...rest }) => {
  const { t } = useTranslation();

  return (
    <Button className={className} onClick={onClick} size="small" {...rest}>
      {t('TripDetails.Itinerary.Trigger.Label')}
    </Button>
  );
};

ItineraryOverlayTrigger.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
};

export default ItineraryOverlayTrigger;
